import styled from "@emotion/styled";
import { Ui } from "@silvertours/front-shared";
var StyledInput = /*#__PURE__*/ styled(Ui.Input, {
    target: "e1jrd9ib0"
})("input{height:3.5rem;font-weight:600;& + svg{top:1rem;}}");
export { StyledInput };
